<template>
  <v-card>
    <v-container>
      <v-row>
        <v-col cols="12" md="8">
          <inner-image-zoom
            id="mainImage"
            :class="{ enlarge: enlarge }"
            :src="photo.url"
            :zoom-src="photo.url"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-card-title></v-card-title>

          <v-card-text>
            <p>{{ chainName }}</p>
            <p>{{ photo.name }}</p>
            <p v-if="photo.geocode">
              Geocode: {{ photo.geocode }}
              <a :href="geocodeLink" target="_blank"
                ><v-icon right>mdi-open-in-new</v-icon>View on map</a
              >
            </p>
            <v-btn right color="primary" class="mt-2" @click="downloadImage()">
              Download
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import InnerImageZoom from "vue-inner-image-zoom";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import { mapGetters } from "vuex";
import { DownloadService } from "@/common/api.service";

export default {
  name: "SingleImageLarge",
  components: {
    InnerImageZoom,
  },
  props: {
    photo: {
      type: Object,
      required: false,
    },
    index: null,
  },
  data: () => ({
    added: false,
    enlarge: false,
  }),
  computed: {
    chainName() {
      return this.photo.calls.stores.chains.name;
    },
    geocodeLink() {
      let latlon = [];
      let latlonComma = "";
      if (this.photo.geocode) {
        if (this.photo.geocode.indexOf("-") !== -1) {
          latlon = this.photo.geocode.split("-");
          latlonComma = `${latlon[0]},-${latlon[1]}`;
        } else {
          latlon = this.photo.geocode.split(".");
          const firstOfLon = latlon[1].slice(-1);
          const endOfLat = latlon[1].slice(0, -1);
          latlonComma = `${latlon[0]}.${endOfLat},${firstOfLon}.${latlon[2]}`;
        }
        console.log(
          "%cSingleImageLarge.vue line:80 object",
          "color: #007acc;",
          latlon
        );
        return `https://google.com/maps/search/?api=1&query=${latlonComma}`;
      }
      return null;
    },
    ...mapGetters(["selectedImagesIds", "activeExpClient"]),
  },
  mounted() {
    // Set up a fake large image.
    const sourceImage = document.createElement("img");
    sourceImage.src = this.photo.url;
    const self = this;
    this.$nextTick(() => {
      setTimeout(function spoofZoomImage() {
        const imgWidth = document.querySelector(".iiz__img").width;
        if (imgWidth < 1000) {
          self.enlarge = true;
          console.log(this.enlarge);
        }
      }, 500);
    });
    this.enlarge = true;
  },
  methods: {
    downloadImage() {
      const params = {};
      params.name = this.photo.id;
      params.photo_ids = [this.photo.id];
      params.naming_structure = "id";
      params.client_id = this.activeExpClient.id;
      params.csv_only = false;
      params.watermark = false;
      params.imageCount = 1;

      DownloadService.zip(params);
    },
  },
};
</script>

<style>
.enlarge .iiz__zoom-img {
  width: 200% !important;
  height: 200% !important;
  max-width: 200% !important;
  max-height: 200% !important;
}
</style>
